import { PERMISSIONS, type Permission } from "@/constants/roles";
import { ROUTES } from "@/constants/routes";
import type { UserRole } from "@/types";

/**
 * Checks if a role has a specific permission
 */
export const hasPermission = (
  role: UserRole | undefined,
  permission: Permission,
): boolean => {
  if (!role) return false;
  return PERMISSIONS[permission].includes(role);
};

/**
 * Checks if user can access a backoffice route by role
 */
export const canAccessRoute = (
  role: UserRole | undefined,
  pathname: string,
): boolean => {
  if (!role) return false;

  if (pathname.startsWith(ROUTES.backoffice.admin)) {
    return role === "ADMIN";
  }

  if (pathname.startsWith(ROUTES.backoffice.moderar)) {
    return role === "ADMIN" || role === "MODERATOR";
  }

  if (pathname.startsWith(ROUTES.backoffice.manager)) {
    return role === "ADMIN" || role === "MANAGER";
  }

  return false;
};

/**
 * Validates tenant-scoped access for MANAGER role
 */
export const isTenantScoped = (
  role: UserRole | undefined,
  userTenantId: string | undefined,
  targetTenantId: string | undefined,
): boolean => {
  if (!role) return false;
  if (role === "ADMIN") return true;
  if (role === "MANAGER") {
    return Boolean(
      userTenantId && targetTenantId && userTenantId === targetTenantId,
    );
  }
  return false;
};
